"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
angular_1.default.module('qualtrics.results', [
    'reporting.dashboards'
]);
angular_1.default.module('reporting.dashboards.services', []);
angular_1.default.module('reporting.dashboards.controllers', []);
angular_1.default.module('reporting.dashboards.directives', []);
angular_1.default.module('reporting.dashboards.filters', []);
angular_1.default.module('reporting.dashboards', [
    'reporting.dashboards.services',
    'reporting.dashboards.controllers',
    'reporting.dashboards.directives',
    'reporting.dashboards.filters',
    'ripsaw',
    'ripsaw.widgets',
    'ngRoute',
    'angularMoment',
    'mgcrea.ngStrap',
    'research-suite-wrapper',
    'pascalprecht.translate',
    'qstrap'
]);
(function (angularModule) {
    angularModule
        .config([
        '$routeProvider',
        '$translateProvider',
        '$locationProvider',
        'rsConfigProvider',
        function ($routeProvider, $translateProvider, $locationProvider, rsConfigProvider) {
            var config = {};
            config.containers = '/results/public/ripsaw/containers';
            config.registry = '/results/public/ripsaw/v2/registry';
            config.fieldsets = '/results/public/fieldsets';
            config.progress = '/results/public/progress';
            config.surveys = '/results/public/surveys';
            config.responses = '/results/public/aggregate/fieldsets';
            // Ripsaw-server cannot be fully deprecated yet. We shouldn't ever hit this route,
            // but still need to configure it so ripsaw-cli doesn't error.
            // See gitlab-app.eng.qops.net/reporting-framework/ripsaw-client/merge_requests/271
            config.ripsaw_server_surveys = 'http://ripsaw:80/ripsaw';
            rsConfigProvider.init(config);
            $locationProvider.hashPrefix('');
            $routeProvider.when('/', {});
            $routeProvider.when('/pages/:pageId', {});
            $translateProvider.useSanitizeValueStrategy('escapeParameters');
            $translateProvider.useLoaderCache();
            // prefix and suffix are empty so we get just the lang key (ie, ES, EN)
            // That key is what is in qmessages
            $translateProvider.useStaticFilesLoader({
                prefix: '',
                suffix: ''
            });
            var preferredLanguage = window.userLang || 'EN';
            if (preferredLanguage !== 'DEV') {
                // TODO use the lang of the browser if it is in the whitelist?
                $translateProvider.fallbackLanguage('EN');
                $translateProvider.preferredLanguage(preferredLanguage.toUpperCase());
            }
            else {
                window.userLang = 'EN';
            }
        }
    ])
        .constant('RUM_URL', '/rum/genesis-dev-client-logging')
        .constant('BASE_EXPORT_URL', '/results/public/file-exports')
        .run([
        '$location',
        'RUM_URL',
        '$http',
        'rsEnvironment',
        '$window',
        '$route',
        function ($location, RUM_URL, $http, rsEnv, $window) {
            rsEnv.set('isPublic', true);
            setTimeout(function () {
                var loadTime = null;
                if ($window.performance && $window.performance.timing) {
                    loadTime = $window.performance.timing.domContentLoadedEventEnd - $window.performance.timing.navigationStart;
                }
                var environment = rsEnv.get('environment');
                var dc = rsEnv.get('dc');
                var data = {
                    timingType: 'page load',
                    timingId: 'results-loaded-page',
                    measure: loadTime,
                    timestamp: (new Date()).toUTCString(),
                    sessionId: null,
                    qHostname: environment + '.' + dc,
                    path: $location.url()
                };
                if (environment === 'dev') {
                    console.log('page load time', data);
                }
                else {
                    $http.get(RUM_URL + '?' + JSON.stringify(data));
                }
            }, 1000);
        }
    ]);
})(angular_1.default.module('reporting.dashboards'));
